<template>
  <div class="banner" style="width: 770px;margin: 0 auto 58px">
    <div class="banner_box">
      <!-- 左边工程材料 -->
      <div class="banner_box_inner1 cursor">
        <!-- banner-1级分类 -->
        <div v-if="!list.bannerMenu.length">
        <div class="material 1" v-for="(item,index) in 10" :key="index">
          <div class="newMaterial_top font14">
            <div class="left">
              <el-skeleton  animated :count="1" style="width: 100%">
                <template slot="template">
                <span style="display: inline-block">
                  <el-skeleton-item variant="image" style="width: 22px; height: 22px;" />
                </span>
                  <span style="margin-left: 10px;line-height: 22px">
                  <el-skeleton-item variant="text" style="width: 100px;" />
                </span>
                </template>
              </el-skeleton>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        </div>
        <div
          class="material"
          v-for="(item, index) in list.bannerMenu"
          :key="index"
          :class="[
            { color02: index === bs_show_menu },
            { 'icon-hover': index === bs_show_menu }
          ]"
          @click="toFlexibleEmployment([item.no])"
          @mousemove="mousemoveTwo(index, item.children)"
          @mouseleave="mouseouts"
        >
          <div class="newMaterial_top font14">
            <div class="left">
              <img :src="item.pcIcon" />
              <span style="white-space:nowrap;max-width: 116px;text-overflow:ellipsis;overflow:hidden;">{{ item.name }}</span>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>

          <div class="banner_menu font14 aa" v-show="bs_show_menus == index">
            <div class="banner-menu-container">
              <div
                class="menu-child-list"
                v-for="(item2, index2) in list.bannerMenu[index].children"
                :key="index2"
                @mousemove="SecMousemove(index2)"
                @mouseleave="SecMouseout"
              >
                <!-- 二级菜单 -->
                <div
                  class="cursor menu-child-second"
                  @click.stop="toFlexibleEmployment([item.no,item2.no])"
                >
                  <div class="child-second-tit" :title="item2.name">
                    {{ item2.name }}
                  </div>
                </div>
                <!-- 三级菜单 -->
                <div class="menu-child-three">
                  <span
                    class="cursor"
                    v-for="(inx, secindex) in item2.children"
                    :key="secindex"
                    @click.stop="toFlexibleEmployment([item.no,item2.no,inx.no])"
                  >
                    {{ inx.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bannerimg">
        <el-skeleton v-if="!banner_img.length"  animated :count="1" style="width: 100%;height: 450px">
          <template slot="template">
            <el-skeleton-item variant="image" style="width: 100%; height: 450px;" />
          </template>
        </el-skeleton>
        <el-carousel :interval="4000" height="450px" arrow="never" trigger="click">
          <el-carousel-item v-for="(item, index) in banner_img" :key="index">
            <img
              class="cursor"
              :src="item.pic"
              @click="href(item.url)"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--   右边活动公告 -->
      <div class="banner_box_inner2">
        <div class="enter-nav">
          <div class="enter-box">
            <div v-for="(tab, idx) in filtertabsGroup" :key="tab.path + idx">
              <div
                class="cursor box"
                @click="toCenterPage(tab)"
              >
                <img :src="tab.iconUrl" alt />
                <div class="enter-box-title">{{ tab.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <record ref="record"></record>
  </div>
</template>

<script>
import link from "@/public/link.js"
import { apiHome } from "@/api/apiHome"
import { apiRecommendList } from "@/api/apiRecommendList"
import { apiWorker } from "@/api/apiWorker"
import sessionStorage from "@/storage/sessionStorage"
import localStorage from "@/storage/localStorage"
import cookie from "@/storage/cookies.js"
import { mapState } from "vuex"
export default {
  name: "Banner",
  data() {
    return {
      regionId:'',
      link,
      name: "程女士",
      bs_show_menu: -1,
      bs_show_menus: -1,
      secAction: 0,
      banner_img: [],
      tabsGroup: [
        {
          name: "工队发布",
          path: "/teamInfoList3",//企业身份跳
          iconUrl: require("@/assets/bannerIcon/bannerIcon1.png"),
          jumpUserCenter: "",
          identifiersname:'teamInfoEdit'
        },
        {
          name: "工队发布",
          path: "/teamInfoList",//团队和个人身份跳
          iconUrl: require("@/assets/bannerIcon/bannerIcon1.png"),
          jumpUserCenter: "",
          identifiersname:'teamInfoEdit'
        },
        {
          name: "劳务发布",
          path: "/teamLaborService",
          iconUrl: require("@/assets/bannerIcon/bannerIcon2.png"),
          jumpUserCenter: "lwfb",
          identifiersname:'teamLaborService'
        },
        {
          name: "同城用工",
          path: "/labour",
          iconUrl: require("@/assets/bannerIcon/bannerIcon3.png"),
          jumpUserCenter: "gzbj",
          identifiersname:''
        },
        {
          name: "团队人员",
          path: "/gdryList",
          iconUrl: require("@/assets/bannerIcon/bannerIcon4.png"),
          jumpUserCenter: "tdry",
          identifiersname:'gdryList'
        },
        {
          name: "设备管理",
          path: "/teamEqList",
          iconUrl: require("@/assets/bannerIcon/bannerIcon5.png"),
          jumpUserCenter: "zysb",
          identifiersname:'teamEqList'
        },
        {
          name: "经营业绩",
          path: "/businessPerformance",
          iconUrl: require("@/assets/bannerIcon/bannerIcon6.png"),
          jumpUserCenter: "gcyj",
          identifiersname:'gdyjList'
        },
        {
          name: "工队相册",
          path: "/teamPhoto",
          iconUrl: require("@/assets/bannerIcon/bannerIcon7.png"),
          jumpUserCenter: "",
          identifiersname:'teamPhoto'
        },
        {
          name: "记工记账",
          path: "/record",
          iconUrl: require("@/assets/bannerIcon/bannerIcon11.png"),
          jumpUserCenter: "",
          identifiersname:''
        },
        {
          name: "专业工人",
          path: "/needsWorkerList",
          iconUrl: require("@/assets/bannerIcon/bannerIcon9.png"),
          jumpUserCenter: "",
          identifiersname:''

        },
        {
          name: "会员中心",
          path: "/memberCenter",
          iconUrl: require("@/assets/bannerIcon/bannerIcon10.png"),
          jumpUserCenter: "",
          identifiersname:''
        }
      ],
      icon: [
        "&#xe632;",
        "&#xe645;",
        "&#xe6d2;",
        "&#xe620;",
        "&#xe666;",
        "&#xe608;",
        "&#xe644;"
      ],
      announcement: [
        {
          name: "【新用户如何注册账号？】",
          path: "/howsign"
        },
        {
          name: "【如何在平台购买商品？】",
          path: "/howtobuy"
        },
        {
          name: "【如何查看招标公告？】",
          path: "/bidinviting"
        },
        {
          name: "【如何联系平台客服？】",
          path: "/servicetel"
        },
        {
          name: "【如何查看中标公告？】",
          path: "/tenderaccepted"
        },
        {
          name: "【如何在平台购买商品？】",
          path: "/howtobuy"
        }
      ],
      more: {
        url: "/static/img/banner_logo_more.png",
        text: "更多"
      },
      list: {
        bannerMenu: []
      },
      imgList: [
        {
          url: require("@/assets/team/teamIcon1.png")
        },
        {
          url: require("@/assets/team/teamIcon2.png")
        },
        {
          url: require("@/assets/team/teamIcon3.png")
        },
        {
          url: require("@/assets/team/teamIcon4.png")
        },
        {
          url: require("@/assets/team/teamIcon5.png")
        },
        {
          url: require("@/assets/team/teamIcon6.png")
        },
        {
          url: require("@/assets/team/teamIcon7.png")
        },
        {
          url: require("@/assets/team/teamIcon8.png")
        },
        {
          url: require("@/assets/team/teamIcon9.png")
        },
        {
          url: require("@/assets/team/teamIcon10.png")
        }
      ]
    }
  },
  components:{
    record: () => import("./record"), // 记工记账窗口
  },
  computed: {
    ...mapState({
      userState: state => state.user
    }),
    filtertabsGroup() {
      if (!this.userState.type&&this.userState.type!=0) {//未登录也要返回菜单
          return this.tabsGroup.filter(item => item.path!='/teamInfoList')
      }else if (this.userState.type === 0||this.userState.type === 2) {//个人团队身份
          return this.tabsGroup.filter(item => item.path!='/teamInfoList3')
      } else if (this.userState.type === 1) {//企业身份
          return this.tabsGroup.filter(item => item.path!='/teamInfoList')
        }
    }
  },
  methods: {
    //跳转临时用工搜索
    toFlexibleEmployment(item){
      if (!item[0]) {
        this.$router.push({ path: `/FlexibleEmployment` })
      } else {
        let query = JSON.stringify(item)
        sessionStorage.save("query", query)
        this.$router.push({ path: `/FlexibleEmployment` })
      }
    },
    /** @name banner-1级分类跳转 */
    toView_one(item) {
      if (item.name === "更多") {
        this.$router.push({ path: `/teamList` })
      } else {
        this.$store.commit("SET_INDEXKEY", 1)
        localStorage.set("indexKey", 1)
        let query = {
          team: 1,
          item: item,
          type: "one"
        }
        query = JSON.stringify(query)
        sessionStorage.save("query", query)
        this.$router.push({ path: `/teamList` })
      }
    },
    /** @name 2级分类跳转 */
    toView_two(item) {
      this.$store.commit("SET_INDEXKEY", 1)
      localStorage.set("indexKey", 1)
      //
      let query = {
        team: 1,
        item,
        type: "two",
        parentId: item.parentNo
      }
      query = JSON.stringify(query)
      sessionStorage.save("query", query)
      this.$router.push({ path: `/teamList`, query: { tabIndex: 1 } })
    },
    /** @name 3级分类跳转 */
    toView_three(third, second) {
      //
      //
      this.$store.commit("SET_INDEXKEY", 1)
      localStorage.set("indexKey", 1)
      let query = {
        team: 1,
        third,
        second,
        type: "three",
        firstNo: second.parentNo,
        secondNo: third.parentNo
      }
      query = JSON.stringify(query)
      //
      sessionStorage.save("query", query)
      this.$router.push({ path: `/teamList` })
    },
    // 快捷入口跳转
    toCenterPage(tab) {
      const routerPath = `${process.env.VUE_APP_PERSONURL}${tab.path}`

      const rules = {
        login:!['同城用工','专业工人'].includes(tab.name),
        realName:!['同城用工','专业工人','记工记账','会员中心'].includes(tab.name),
        type: ['工队发布','团队人员','设备管理','经营业绩','工队相册','劳务发布'].includes(tab.name) ? ['person', 'company', 'team'] : undefined
      }

      if(this.permissionTips(rules)) return

      if(tab.name==='记工记账'){
        this.$refs.record.path=tab.path
        this.$refs.record.show=true
      } else if(tab.name==='会员中心'){
        link.personal()
      }else if(tab.name==='专业工人'){
        this.$router.push('/worker')
      }else if(tab.name==='同城用工'){
        this.$router.push('/labour')
      }else {
        window.open(routerPath)
      }

    },
    //获取菜单列表
    async axios_infoAll() {
      // 一级菜单
      let result = await apiWorker.getListChild()
      //let result = await apiRecommendList.fetchTeamCategory()
      let arr = []
      arr = result.data.data

      arr.forEach((item, index) => {
        if (index < 9) {
          this.list.bannerMenu.push(item)
        }
      })
      const res = await apiWorker.getLobarDefault()
      if(res.data.code === 200){
        const { name,pcIcon } = res.data.data
        let more = { name,pcIcon }
        this.list.bannerMenu.push(more)
      }
    },
    login() {
      link.login()
    },
    href(url) {
      if(!url){
        return ''
      }
      window.location.href = url
    },
    mousemoveTwo(index, child) {
      if (index === 9 || !child) {
        this.bs_show_menus = -1
      } else {
        this.bs_show_menus = index
      }
    },
    mouseout(index) {
      this.bs_show_menu = -1
      this.secAction = -1
    },
    // 工程工队鼠标离开事件
    mouseouts(index) {
      this.bs_show_menus = -1
      this.secAction = -1
    },
    SecMousemove(index) {
      this.secAction = index
    },
    SecMouseout() {
      this.secAction = -1
      this.bs_show_menus = -1
    },
    // 获取中间banner
    async axios_getBannerImage() {
      if (cookie.cookieRead("area") &&JSON.stringify(cookie.cookieRead("area")) !== "{}") {
        let area = cookie.cookieRead("area");
        this.regionId = JSON.parse(area);
      }else{
        this.regionId = {areaName: "新疆维吾尔自治区",
                checked: true,
                id: 650000,
                lat: "43.792816",
                level: 1,
                lng: "87.617729",
                shortName: "新疆"}
      }
      // let result = await apiHome.fetchBannerList()
      let result = await apiHome.getBanner({
        type: 6,
        // regionId: JSON.parse(cookie.cookieRead("area")).id
        regionId: this.regionId.id
      })
      this.banner_img = result.data.data
    }
  },
  async created() {
    await this.axios_getBannerImage()
    await this.axios_infoAll()
  },
  watch: {
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
@media screen and(min-width:1200px) {
  .banner {
    .banner_box {
      width: 1200px;
    }
  }
}
@media screen and(max-width:1200px) {
  .banner {
    .banner_box {
      width: 1200px;
    }
  }
}
@media screen and(max-width:992px) {
  .banner {
    width: 992px !important;
    .banner_box {
      width: 992px;
      .banner_menu {
        width: 538px;
        left: 70%;
        .banner_menu_two {
          width: 100%;
        }
      }
      // .banner_box_inner1 {
      //   left: 208px;
      // }
      // .banner_box_inner2 {
      //   right: -50px;
      // }
    }
  }
}
.bannerimg{
  margin: 0 220px 0 210px;
}
/* 走马灯 */
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.banner {
  width: 100%;
  height: 450px;
  position: relative;
}

.banner_box {
  width: 1200px;
  height: 450px;
  margin: 0 0 0 -600px;
  position: absolute;
  left: 50%;
}

/* 菜单展开项 */
.banner_menu {
  width: 788px;
  height: 449px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: $color-white;
  background-position: right 100px;
  background-size: 464px 323px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 200px;
  z-index: 10;
  border: 1px solid #dfe4ea;
  .banner-menu-container {
    width: 779px;
    float: left;
    padding-top: 15px;
    padding-right: 20px;
    padding-left: 10px;

    .menu-child-list {
      display: flex;
      margin-bottom: 20px;
      font-size: 12px;
      .menu-child-second {
        width: 115px;
        padding-right: 10px;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        font-weight: bold;

        &:hover {
          color: $primary-blue;
        }
        .child-second-tit {
          width: 115px;
          margin-right: 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          color: #333333;
          &:hover {
            // color: #0285df;
            color: #b79255;
          }
        }
      }

      .menu-child-three {
        flex: 1;

        span {
          color: #656565;
          display: inline-block;
          padding-left: 10px;
          margin-right: 10px;
          margin-top: 4px;
          // margin-top: 10px;
          margin-bottom: 8px;
          font-size: 12px;
          line-height: 1;
          border-left: 1px solid #bdbdbd;

          &:hover {
            // color: $primary-blue;
            color: #b79255;
          }
        }
      }
    }
  }
  .banner-bg-font {
    line-height: 35px;
    font-family: "FZSuXSYBJW";
    position: absolute;
    width: 300px;
    left: 60px;
    top: 200px;
    .banner-btn {
      font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
      color: $default;
      width: 96px;
      height: 38px;
      border: 1px solid $default;
      text-align: center;
      margin-top: 10px;
    }
  }
}

.enter-nav {
  /*border-bottom: 1px solid #f5f5f5;*/
  .enter-box {
    // height: 170px;
    height: 225px;
    display: flex;
    flex-wrap: wrap;
    /*border-bottom: 1px dotted #dfe4ea;*/
    padding-top: 10px;
    padding-bottom: 21px;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      .box {
        width: 72px;
        height: 70px;
        text-align: center;
        margin: 0 5px 20px 20px;
        .enter-box-title {
          font-size: 12px;
          color: rgba(51, 51, 51, 1);
          &:hover{
            color: #B79255;
          }
        }
        img {
          width: 30px;
          height: 30px;
          padding-top: 6px;
          padding-bottom: 5px;
        }
      }
    }
  }
}

.twomenu {
  float: left;
}
.icon-hover {
  .iconfont {
    color: $default;
  }
}
.banner-menu-Newcontainer {
  width: 790px;
  float: left;
  min-height: 450px;
  position: relative;
  font-size: 14px;
  .menu-child-list {
    // border: 1px solid red;

    .menu-child-left {
      width: 134px;
      margin-right: 5px;
      padding: 14px 20px 14px 20px;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      font-weight: bold;
      align-items: flex-start;
      background: #fafafa;
      color: #000;
      &:hover {
        color: $primary-blue;
        background: #fff;
        cursor: pointer;
      }
      .child-second-tit {
        width: 80px;
        width: 115px;
        width: 100%;
        margin-right: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          width: 84px;
          width: 110px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 400;
          font-size: 14px;
          height: 15px;
          line-height: 15px;
        }
        i {
          position: relative;
          top: 1px;
        }
      }
    }
    .isLeftAction {
      color: $primary-blue;
      background: #fff;
    }
    .menu-child-right {
      // outline: 1px solid red;
      background: white;
      position: absolute;
      min-height: 450px;
      min-height: 635px;
      min-height: 570px;
      // width: 560px;
      width: 140px;
      top: 0;
      left: 170px;
      padding: 0 20px;
      .secItem {
        border-bottom: 1px solid #dfe4ea;
        padding: 15px 0;
        font-size: 14px;
        line-height: 15px;
        width: 140px;
        .seconditems {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 140px;
          .secItemData {
            color: #333;
            cursor: pointer;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
            &:hover {
              color: $primary-blue;
            }
          }
        }
        .thirditems {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 140px;
          padding: 15px 0;
          .thirdData {
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
        }
        .thinx-right {
          border-bottom: 1px solid #dfe4ea;
        }
        .thrItemList {
          margin-top: 15px;
          margin-top: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          .cursor {
            margin-right: 20px;
            // margin-bottom: 5px;

            margin-top: 5px;
            cursor: pointer;
            color: #666;
            font-size: 14px;
            height: 15px;
            line-height: 15px;
            &:hover {
              color: $primary-blue;
            }
          }
        }
      }
    }
  }
}
//修改新版本需求
.banner-menu-container1 {
  width: 790px;
  float: left;

  .menu-child-list {
    display: flex;
    margin-bottom: 20px;
    font-size: 12px;

    .menu-child-second {
      width: 91px;
      width: 110px;
      margin-right: 5px;
      margin-top: 8px;
      padding-left: 30px;
      text-align: right;
      text-align: left;
      display: flex;
      justify-content: flex-end;
      justify-content: flex-start;
      font-weight: bold;
      align-items: flex-start;
      &:hover {
        color: $primary-blue;
      }

      .child-second-tit {
        width: 80px;
        width: 115px;
        margin-right: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > div {
          width: 84px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        i {
          position: relative;
          top: 1px;
        }
      }
    }

    .menu-child-three {
      flex: 1;
      span {
        color: #666666;
        display: inline-block;
        margin-right: 30px;
        margin-top: 8px;

        &:hover {
          color: $primary-blue;
        }
      }
    }
  }
}

/* 二级菜单 */
.banner_menu_two {
  width: 170px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
  background-color: #fafafa;
  // margin: 0 auto;
}

.banner_menu_two > div {
  vertical-align: top;
  padding-top: 15px;
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
}

/* 一级菜单 */
.banner_menu_two > div:nth-child(1) {
  padding: {
    left: 20px;
    right: 30px;
  }
}

/* 一级菜单hover效果 */
.banner_menu_two > div:nth-child(1):hover {
  color: $default;
}
.banner_menu_two > div:nth-child(2) {
  margin: {
    left: 20px;
    right: 30px;
  }
  padding: {
    top: 15px;
    bottom: 10px;
  }
  font-size: 12px;
  color: #747474;
}

/* 二级菜单 */
.banner_menu_two > div:nth-child(2) > div {
  display: inline-block;
  margin-bottom: 7px;
  padding-right: 30px;
  position: relative;
  line-height: 14px;
}

/* 二级菜单hover效果 */
.banner_menu_two > div:nth-child(2) > div:hover {
  color: $default;
}

.banner_box_inner1 {
  width: 200px;
  height: 450px;
  background: linear-gradient(180deg, #F8EAD0 0%, #F9E8C9 100%);
  position: absolute;
  left: 0;
  top: 0;
  // border: 1px solid $default;
  z-index: 10;
}

.banner_box_inner2 {
  width: 210px;
  height: 450px;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(180deg, #F8EAD0 0%, #F9E8C9 100%);
  // border-top: 1px solid $default;
  z-index: 10;
}

.material {
  width: 198px;
  width: 200px;
  height: 44.8px;
  float: left;
}

.material:hover {
  // background: #eaf7ff;
  color: #ffffff;
  // background:rgba(255,84,46,0.16);
  background: #B79255;
}
.newMaterial_top {
  font-size: 14px;
  // width: 100%;
  padding: 0 10px;
  height: 46.5px;
  line-height: 46.5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > i {
    // position: absolute;
    // top: 50%;
    // right: 15px;
    // transform: translateY(-50%);
  }
  img {
    display: inline-block;
    width: 22px;
    height: 22px;
    position: relative;
    top: 1px;
    margin-right: 10px;
  }
  .left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.material_top {
  font-size: 16px;
  padding-left: 15px;
  width: 100%;
  height: 46.5px;
  line-height: 46.5px;
  text-indent: 30px;
  background: url(/static/img/logo_right.png) no-repeat 180px 12px;
  position: relative;
  -moz-background-size: 5px 12px; /* 老版本的 Firefox */
  background-size: 5px 12px;
  > i {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
}
.material_top .iconfont {
  position: relative;
  left: -12px;
  top: 5px;
  text-indent: 0px;
  font-size: 16px;
  width: 22px;
  height: 22px;
}
.material_top .moreicon {
  top: 0;
}
/* .material_btom{
    width: 100%;
    height: 20px;
    line-height: 20px;
    margin: 6px 0 0 0;
    font-size: 14px;
    text-indent: 47px;
  } */
.material_more {
  width: 200px;
  height: 50px;
  float: left;
}

.material_img {
  position: absolute;
  left: 20px;
  top: 22px;
}

.login_width {
  width: 210px;
  border-bottom: 1px dashed #cecac7;
}

.login_width_solid {
  color: #333;
  // padding-top: 15px;
  font-size: 14px;
  width: 210px;
  border-bottom: 1px solid #e4e7ed;
  border-top: 1px solid #e4e7ed;
  > div {
    &:nth-child(1) {
      height: 20px;
      // line-height: 30px;
    }
    &:nth-child(2) {
      height: 30px;
      line-height: 30px;
    }
  }
}

.login {
  padding: 20px 0;
  text-align: center;
}

.login_false > div:nth-child(1) {
  width: 100%;
  height: 26px;
}

.announcement {
  height: 28px;
  line-height: 28px;
  padding-left: 15px;
  background: #f5f7fa;
  width: 195px;
  .title {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
  }
  .more {
    color: #808080;
  }
}

.information {
  height: 34px;
  display: flex;
}

.el-button {
  padding: 8px 20px;
  margin: 10px 5px 0 5px;
}

.banner_box_inner2 .el-button--primary {
  background: $default;
  border-color: #0286df;
}

.banner_box_inner2 .el-button--default {
  color: $default;
  border: 1px solid #0286df;
}

.banner_box_inner2 .el-button {
  padding: 6px 18px;
  margin: 15px 10px 0;
}

.fk {
  background: $default;
  width: 4px;
  height: 4px;
  margin: 15px 0 0 14px;
}

.banner_text {
  width: 180px;
  margin: 0 0 0 8px;
  white-space: nowrap;
  display: block;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 34px;
}

.banner_data {
  float: left;
  font-size: 12px;
  line-height: 34px;
  margin: 0 0 0 14px;
}

.block {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  img {
    width: 100%;
    height: 100%;
  }
}

.enter-title {
  height: 48px;
  line-height: 48px;
  text-align: center;
  padding-left: 10px;
  text-align: center;
  font-weight: 400;
  border-bottom: 1px solid #f5f5f5;
}

.quickentry {
  display: flex;
  .quickentry-box {
    height: 67px;
    width: 70px;
    text-align: center;
    border-right: 1px solid #f5f5f5;
    &:last-child {
      border: none;
    }
    img {
      padding: 14px 0 3px 0;
    }
    div {
      color: #666666;
      font-size: 12px;
      line-height: 12px;
    }
  }
}
</style>
